import SectionHeading from '../../../components/SectionHeading'
import Form from './Form'

const SecContact = () => {
    return (
        <div className="contact_us_area" id="contact">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SectionHeading
                      title="Contact With Us"
                      text="Have questions or need assistance? Reach out to the StonFi AI team for support. We're here to help you navigate the world of DeFi and AI-powered solutions."
                />
              </div>
            </div>
            <Form />
          </div>
        </div>
    );
}

export default SecContact